<script setup>
import { marked } from 'marked';

defineProps({
  value: {
    type: String,
    required: true,
  },
});

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
  const html = linkRenderer.call(renderer, href, title, text);

  return html.replace(/^<a /, '<a target="_blank" ');
};

const safeHtmlConfig = { ALLOWED_TAGS: ['a'] };
</script>

<template>
  <div v-safe-html:[safeHtmlConfig]="marked(value, { renderer })" />
</template>
